import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=644c470a&"
import script from "./FileField.vue?vue&type=script&lang=js&"
export * from "./FileField.vue?vue&type=script&lang=js&"
import style0 from "./FileField.vue?vue&type=style&index=0&id=644c470a&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644c470a')) {
      api.createRecord('644c470a', component.options)
    } else {
      api.reload('644c470a', component.options)
    }
    module.hot.accept("./FileField.vue?vue&type=template&id=644c470a&", function () {
      api.rerender('644c470a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file/FileField.vue"
export default component.exports